import request from '@/utils/request'
// let orgCode = window.sessionStorage.getItem("orgCode");

// 密码登录方法
export function login(username, password, code, uuid) {
  //
  // const data = {
  //   username,
  //   password,
  //   code,
  //   uuid,
  //   userType:'01',
  //   orgCode:window.sessionStorage.getItem("orgCode")
  // }
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  params.append('code', code);
  params.append('uuid', uuid);
  params.append('userType', '01');
  params.append('orgCode', window.sessionStorage.getItem("orgCode"));

  return request({
    url: '/login',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}

// 手机号登录方法
export function loginByphone(phone, password, code) {

  const data = {
    phone,
    password,
    code,
    orgCode: window.sessionStorage.getItem("orgCode")
  }
  return request({
    url: '/system/user/registerByPhone',
    method: 'post',
    data: data
  })
}
//验证账号是否过期
export function isExpiration() {
  return request({
      url: '/bussiness/user/isExpiration',
      method: 'post'
  });
};

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  //
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCode(data) {
  //
  let dataObj = Object.assign(
    { orgCode: window.sessionStorage.getItem("orgCode") },
    data
  );
  return request({
    url: '/system/user/getPhoneCode',
    params: dataObj,
    method: 'post'
  })
}

// 获取验证码(新)
export function getNewCode(data) {
  //
  let dataObj = Object.assign(
    { orgCode: window.sessionStorage.getItem("orgCode") },
    data
  );
  return request({
    url: '/system/user/getYZCode',
    params: dataObj,
    method: 'post'
  })
}
// 获取图片验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}
//密码重置
export function getPasswordApi(obj) {
  //
  const data = {
    phone: obj.phone.trim(),
    password: obj.passwordSet,
    code: obj.verifyCode,
    userType: '01',
    orgCode: window.sessionStorage.getItem("orgCode")
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}

//密码修改
export function editPasswordApi(obj) {

  const data = {
    phone: obj.phone.trim(),
    password: obj.password,
    newPassword: obj.newPassword,
    // userType:'01',
    orgCode: window.sessionStorage.getItem("orgCode")
  }
  return request({
    url: '/system/user/updatePassword',
    method: 'put',
    data: data
  })
}

// 同意协议
export function getArgee() {
  const data = {}
  return request({
    url: '/bussiness/web/addAgreeProtocol',
    method: 'post',
    data: data
  })
}

// 查询协议
export function queryProtocol() {
  const data = {
  }
  return request({
    url: '/bussiness/web/getAgreeProtocol',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js